/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/24/20
 * Time: 3:25 PM
 */
export const INSTITUTE_HANDLER = 'INSTITUTE_HANDLER';
export const FETCH_TEACHERS = 'FETCH_TEACHERS';
